import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { CompanyResponse, Company } from '../_models/company.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  companyUrl = 'api/PspCompany/GetAllCompanies';

  constructor(private http: HttpClient) { }

  getAllCompanies(): Observable<CompanyResponse> {
    return this.http.get<CompanyResponse>(this.companyUrl);
  }


  }
